import '../plugins/slickPlugin';

// slick init
export default function initM66() {
  jQuery('.module-m66-slider').each(function () {
    let $slider = $(this);
    $slider.find('.module-m66-slider-text-slider').on('afterChange', function (event, slick, currentSlide) {
      if ($(window).width() > 991) {
        $slider.find('.module-m66-slider-image').slick('slickGoTo', currentSlide);
      } else {
        $slider.find('.module-m66-slider-image-mobile').slick('slickGoTo', currentSlide);
      }
    });
    $slider.find('.module-m66-slider-text-slider').slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      dots: true,
      // waitForAnimate: false,
      arrows: false,
      dotsClass: 'm66-slider-bars',
      appendDots: $('.module-m66-slider-bars'),
      asNavFor: $slider.find('.module-m66-slider-image'),
    });

    $slider.find('.module-m66-slider-image').slick({
      infinite: true,
      // waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      asNavFor: $slider.find('.module-m66-slider-text-slider'),
    });

    $slider
      .find('.module-m66-slider-image-mobile')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        // waitForAnimate: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        asNavFor: $slider.find('.module-m66-slider-text-slider'),
      });
  });
}
